/* eslint-disable react/prop-types */
import classes from "./splash-banner.module.scss";
import Label from "@/components-library/widgets/label";
import Button from "@/components-library/widgets/button";
import Flex from "@/components-library/layout/flex";

function SplashBanner({ home, onFindOutClick }) {
  const background = "/images/home/prossimiti-home-hero.jpg";

  return (
    <Flex
      align="center"
      direction="column"
      justify="flex-start"
      className={classes.spashImage}
      style={{ backgroundImage: `url(${background})` }}
    >
      <Label tag="h1" weight="bold" className={classes.title}>
        {home.title}
      </Label>
      <div className={classes.mdSpace} />
      <Label weight="bold" tag="h4">
        {home.subTitle}
      </Label>

      <div className={classes.smSpace} />
      <Button
        size="sm"
        color="primary"
        className={classes.button}
        onClick={onFindOutClick}
      >
        SCOPRI DI PIU
      </Button>
    </Flex>
  );
}

export default SplashBanner;
